import { render, staticRenderFns } from "./markeing-header.vue?vue&type=template&id=29917280&scoped=true&"
import script from "./markeing-header.vue?vue&type=script&lang=js&"
export * from "./markeing-header.vue?vue&type=script&lang=js&"
import style0 from "./markeing-header.vue?vue&type=style&index=0&id=29917280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29917280",
  null
  
)

export default component.exports